export default __webpack_public_path__ + "static/media/Snd_BigLineDownCorner.e2d4c642.mp3";